import clx from 'classnames';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonProps } from '@/atoms/Button';
import ButtonOrLink from '@/atoms/ButtonOrLink/ButtonOrLink';

type PropsType = {
  image?: string;
  icon?: string;
  children: ReactNode;
  subLine: string;
  className?: string;
  buttonProps?: ButtonProps;
  error?: string;
};

const MetricCompact = ({ icon, children, subLine, className, buttonProps, error }: PropsType) => {
  const { t } = useTranslation();

  return (
    <ButtonOrLink
      {...buttonProps}
      className={clx(
        'rounded-tl-2xl rounded-br-2xl px-3 py-2 flex flex-col gap-2 bg-mercury-100 border-4 border-mercury-200 text-left group',
        'hover:bg-mercury-200 hover:border-mercury-300 transition-all',
        className,
      )}
    >
      <div className="">
        <div className="flex flex-col gap-2 justify-end">
          <span className="title-2 text-gold-500 group-active:text-gold-50">{children}</span>
          {subLine && <h6 className="sm-bold-caps text-neutral-600 group-active:text-neutral-50">{t(subLine)}</h6>}
        </div>
        {icon && <i className={clx(icon, ' text-gold-500 group-active:text-gold-50 text-6xl')} />}
      </div>
      {error && (
        <p className="text-system-error-400 group-active:text-system-error-200">
          <i className="fa-solid fa-triangle-exclamation" />
          {error}
        </p>
      )}
    </ButtonOrLink>
  );
};

export default MetricCompact;
